export { utf8ToBytes } from './utf8ToBytes';
//# sourceMappingURL=index.js.map